import { useState, useContext, useEffect } from 'react';
import { useHistory } from "react-router-dom";

import classes from './TriviaPage.module.scss';

import UserContext from '../store/user-context';
import TriviaContext from '../store/trivia-context';

import Button from '../components/ui/Button';
import QNumber from '../components/ui/QNumber';
import QOption from '../components/ui/QOption';
import Loading from '../components/layout/Loading';
import Modal from '../components/layout/Modal';
import Prompt from '../components/ui/Prompt';
import Title from '../components/ui/Title';

function TriviaPage() {
    const userCtx = useContext(UserContext);
    const triviaCtx = useContext(TriviaContext);

    const history = useHistory();
    const [isLoading, setIsLoading] = useState(true);
    const [question, setQuestion] = useState();
    const [actionBtnName, setActionBtnName] = useState('Next');
    const [showModal, setShowModal] = useState();
    const [errorMsg, setErrorMsg] = useState();
    const [showHint, setShowHint] = useState(false);
    const [imagesLoadedCount, setImagesLoadedCount] = useState(0);
    const [levelNo, setLevelNo] = useState();
    const [levelName, setLevelName] = useState();

    const populateQuestion = (async (qno, levelNo) => {
        try {
            setIsLoading(true);
            let question;
            for (let index = 0; index < 4; index++) {
                // (Math.floor(Math.random() * 4));    
                const que = await triviaCtx.populateQuestion(qno, levelNo);
                if (que) {
                    question = que;
                    break;
                }
            }
            if (!question) {
                throw new Error('Unable to populate question. Please restart the quiz.');
            }
            setQuestion(question);
            const loadingTimer = setTimeout(() => {
                setIsLoading(false);
            }, 4000);
            return () => {
                clearTimeout(loadingTimer);
                setIsLoading(null);
            };
        } catch (error) {
            console.log(error);
            setIsLoading(false);
            setErrorMsg(error.message);
            setShowModal(true);
        }
    });


    const hideModalHandler = () => {
        setShowModal(false);
        history.replace("/HomePage");
    }

    useEffect(() => {
        if (!triviaCtx.movieCategory) {
            history.replace("/HomePage");
        } else {
            // Set Game Level Name
            if (triviaCtx.movieCategory === 'Bollywood') {
                setLevelNo(userCtx.bollywood);
                setLevelName('Bollywood - ' + userCtx.bollywood);
                populateQuestion(0, userCtx.bollywood);
            } else {
                setLevelNo(userCtx.hollywood);
                setLevelName('Hollywood - ' + userCtx.hollywood);
                populateQuestion(0, userCtx.hollywood);
            }
        }

        return function cleanup() {
            setIsLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [triviaCtx.movieCategory, history, userCtx.bollywood, userCtx.hollywood]);

    function nextQuestionHandler() {
        const qno = triviaCtx.currentQuestionNo + 1;
        if (triviaCtx.currentQuestionNo === triviaCtx.triviaStatus.length - 2) {
            setActionBtnName('Finish');
        }
        if (triviaCtx.currentQuestionNo < triviaCtx.triviaStatus.length - 1) {
            triviaCtx.setNextQuestion();
            populateQuestion(qno, levelNo);
            triviaCtx.setIsOptionSelectedByUser(false);

            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        } else {
            history.replace("/ResultPage");
        }
    }

    function hideHintHandler() {
        setShowHint(false);
    }
    function showHintHandler() {
        setShowHint(true);
    }

    const imageLoaded = () => {
        if (question.qimg && question.qimg2) {
            if (imagesLoadedCount === 1) {
                setIsLoading(false);
                setImagesLoadedCount(0);
            } else {
                setImagesLoadedCount(imagesLoadedCount + 1);
            }
        } else {
            setIsLoading(false);
            setImagesLoadedCount(0);
        }
    }

    return (
        <div className={classes.trivia}>

            {showModal && <Modal onHideModal={hideModalHandler}>
                <Prompt onHideModal={hideModalHandler} title="Opps! Something went wrong." text={errorMsg} />
            </Modal>}

            {showHint && <Modal onHideModal={hideHintHandler}>
                <Prompt onHideModal={hideHintHandler} title="Hint: Storyline" text={question?.overview} />
            </Modal>}

            { isLoading && <Loading />}

            <Title>
                Level: {levelName}
            </Title>

            <div className={classes["trivia__question-nos"]}>
                {triviaCtx.triviaStatus.map((trivia, index) => <QNumber key={index} qno={trivia.qno} />)}
            </div>
            <p className={classes["trivia__question-text"]}>
                {question?.qtext}
            </p>
            <div className={classes["trivia__question-img"]}>
                <figure>
                    {question?.qimg && <img src={question.qimg} alt="movie poster" onLoad={imageLoaded} />}
                </figure>
                <figure>
                    {question?.qimg2 && <img src={question.qimg2} alt="cast" onLoad={imageLoaded} />}
                </figure>
            </div>

            { question?.overview && <Button onBtnClick={showHintHandler}>Hint</Button>}

            <div className={classes["trivia__question-options"]}>
                {
                    question?.options.map((option, index) =>
                        <QOption key={index} optionNo={index} answerIndex={question.answerIndex}>{option}</QOption>
                    )
                }
            </div>
            <div className={classes["trivia__question-actions"]}>
                {triviaCtx.isOptionSelectedByUser && <Button onBtnClick={nextQuestionHandler}>{actionBtnName}</Button>}
            </div>
            <br /><br />
            <br /><br />
        </div>
    )
}

export default TriviaPage
